/*
 * TunePad
 *
 * Michael S. Horn
 * Northwestern University
 * michael-horn@northwestern.edu
 *
 * This project was funded by the National Science Foundation (grant DRL-1612619).
 * Any opinions, findings and conclusions or recommendations expressed in this
 * material are those of the author(s) and do not necessarily reflect the views
 * of the National Science Foundation (NSF).
 */
import html from './time-dialog.module.html';
import { toInt } from '../../audio';

/**
 * Time Signature Dialog (extends HTMLDialogElement)
 */

export function showTimeDialog(numerator : number, denominator : number, update : (n : number, d : number) => void) {

    const dialog = document.createElement('dialog');
    dialog.innerHTML = html;
    setNumerator(numerator);
    setDenominator(denominator);
    dialog.classList.add('time-signature-dialog');
    document.body.append(dialog);
    dialog.showModal();
    dialog.addEventListener('click', (event) => {
        const r = dialog.getBoundingClientRect();
        const cx = event.clientX;
        const cy = event.clientY;
        if (cy < r.top || cy > r.bottom || cx < r.left || cx > r.right) {
            dialog.close();
            dialog.remove();
        }
    });

    const numField = dialog.querySelector('.numerator') as HTMLInputElement;
    const denField = dialog.querySelector('.denominator') as HTMLInputElement;

    numField?.addEventListener('keypress', e => { if (e.key === 'Enter') { numField.blur(); }});
    denField?.addEventListener('keypress', e => { if (e.key === 'Enter') { denField.blur(); }})
    numField?.addEventListener('input', e => {
        numField.value = numField.value.replaceAll(/[^0-9]/g, '');
    });
    denField?.addEventListener('input', e => {
        denField.value = denField.value.replaceAll(/[^0-9]/g, '');
    });
    numField?.addEventListener('blur', e => {
        setNumerator(getNumerator());
        update(getNumerator(), getDenominator());
    });
    denField?.addEventListener('blur', e => {
        setDenominator(getDenominator());
        update(getNumerator(), getDenominator());
    });

    function setNumerator(n : number) {
        n = Math.max(1, Math.min(32, n));
        (dialog.querySelector('.numerator') as HTMLInputElement).value = `${n}`;
    }

    function setDenominator(d : number) {
        d = [1, 2, 4, 8, 16, 32, 64].includes(d) ? d : 4;
        (dialog.querySelector('.denominator') as HTMLInputElement).value = `${d}`;
    }

    function getNumerator() : number {
        return toInt((dialog.querySelector('.numerator') as HTMLInputElement).value, 4);
    }

    function getDenominator() : number {
        return toInt((dialog.querySelector('.denominator') as HTMLInputElement).value, 4);
    }
}
